__turbopack_context__.v({
  "className": "matterfont_c1f795c1-module__OG4FFW__className",
});
